import { useLazyQuery } from '@apollo/client'
import { summarizeApolloError } from '@deltek/specification-client/core/Utilities/apolloUtils'
import { GetSupportingDocuments } from 'api/graphQL/queries/supportingDocs.queries'
import { useMemo } from 'react'
import { base64toBlob } from 'shared/utils/fileUtils'
import useGlobalSnackbar from 'shared/utils/useGlobalSnackbar'
import { useActionBarActions } from '../ActionBarStore'

export const useSupportingDocumentsQuery = () => {
    const {
        setIsSupportingDocsLoading,
        setSupportingDocsUrl,
    } = useActionBarActions()
    const { showGlobalSnackbar } = useGlobalSnackbar()
    const [
        getSupportingDocuments,
        { loading: isSupportingDocumentsLoading },
    ] = useLazyQuery(GetSupportingDocuments, {
        fetchPolicy: 'no-cache',
        onCompleted: async (data) => {
            try {
                const fileAsBase64 = await data?.getSupportingDocuments
                    ?.supportingDocument
                const fileAsPdfBlob = base64toBlob(fileAsBase64)
                var fileURL = URL.createObjectURL(fileAsPdfBlob)

                setSupportingDocsUrl(fileURL)
            } catch (error) {
                console.warn(error)
                showGlobalSnackbar({
                    variables: {
                        message: 'Error fetching Supporting Documents.',
                        variant: 'error',
                        id: 'getSupportingDocumentsFailed',
                    },
                })
            }
        },
        onError: (err) => {
            showGlobalSnackbar({
                variables: {
                    message: summarizeApolloError(
                        err,
                        'Error fetching Supporting Documents.'
                    ),
                    variant: 'error',
                    id: 'getSupportingDocumentsFailed',
                },
            })
        },
    })
    useMemo(() => {
        setIsSupportingDocsLoading(isSupportingDocumentsLoading)
    }, [isSupportingDocumentsLoading])
    return { getSupportingDocuments }
}
